import { cn } from '@latitude/token-utils';
import { Command as CommandPrimitive } from 'cmdk';
import type { ComponentPropsWithoutRef, ComponentRef, Ref } from 'react';

/**
 * Renders a list of commands.
 *
 * @component
 * @example
 * ```tsx
 * <CommandList>
 *   <CommandItem>Command 1</CommandItem>
 *   <CommandItem>Command 2</CommandItem>
 *   <CommandItem>Command 3</CommandItem>
 * </CommandList>
 * ```
 */
export const CommandList = ({
  hasSearchInput,
  withoutPopover,
  hideScrollbar = true,
  ref,
  ...props
}: ComponentPropsWithoutRef<typeof CommandPrimitive.List> & {
  hasSearchInput?: boolean;
  withoutPopover?: boolean;
  hideScrollbar?: boolean;
} & {
  ref?: Ref<ComponentRef<typeof CommandPrimitive.List>>;
}) => (
  <CommandPrimitive.List
    ref={ref}
    className={cn(
      !withoutPopover && {
        'min-w-[150px] max-h-[300px]': true,
        'overflow-scroll no-scrollbar': hideScrollbar,
        'overflow-y-auto overflow-x-hidden': !hideScrollbar,
        'min-w-[150px] h-min-[135px]': hasSearchInput,
      },
    )}
    {...props}
  />
);

CommandList.displayName = CommandPrimitive.List.displayName;
